/* eslint-disable eqeqeq */
/* eslint-disable default-case */
/* eslint-disable no-redeclare */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable no-eval */
/* eslint-disable no-useless-escape */
import $ from "jquery";
import orderListUtil, { playClickSound, processOrders, tmplparams } from "./order-list-util";
import admin, { getMenuCategory, updatePrices } from "./admin";
import { I18n } from "react-redux-i18n";
import menuitemutil, { populateEditCategory, populateEditMenuItem, toggleAllergen } from "./admin/menuitem";
import { renderCategories, updateLeftTabs, updateRightPane } from "./tables-overview";
import { select, getLocale, touchStart, featureEnabled } from "./auth";
import moment from "moment";

/*
if (typeof menuitemutil != "undefined" && typeof menuitemutil.getLanguage=="undefined")
  menuitemutil.getLanguage = function() {return undefined}
*/

// eslint-disable-next-line no-unused-vars
export const onsave = () => {
  admin.getActiveMenuItems(function (cats) {
    admin.categories = cats;
    updatePrices(admin.categories);
    processOrders(orderListUtil.ordersCache);
    updateRightPane();
    //var visibilityMealStatus = $("#meal_menu .selectable");
    //var visibilityDrinkStatus = $("#drink_menu .selectable");
    //renderCategories(admin.categories.activeMenuCategories, category => category.entityType == "DrinkCategory" && category.isTop, $("#drink_menu_tab").get(0), days, "drink");
    //renderCategories(admin.categories.activeMenuCategories, category => category.entityType == "MealCategory" && category.isTop, $("#meal_menu_tab").get(0), days, "meal");
    /*
  $("#drink_menu .selectable").remove();
  $("#meal_menu .selectable").remove();
  $("#timingSelector").replaceWith($("#timingSelectorTemplate").tmpl(tmplparams()));
  admin.categories.activeMenuCategories.forEach(function (category) {
    if (category.entityType == "DrinkCategory" && category.isTop)
      $("#categoryTemplate")
        .tmpl({ ...category, ...tmplparams() })
        .appendTo("#drink_menu");
  });
  admin.categories.activeMenuCategories.forEach(function (category) {
    if (category.entityType == "MealCategory" && category.isTop)
      $("#categoryTemplate")
        .tmpl({ ...category, ...tmplparams() })
        .appendTo("#meal_menu");
  });
  */
    /*
       $(".menuItemHead").each((ind, e) => e.addEventListener("touchstart", touchStart, {
         capture: true,
         passive: false
       }));
       $(".list-group-item.defaultQuantity").each((ind, e) => e.addEventListener("touchstart", touchStart, {
         capture: true,
         passive: false
       }));
   
       visibilityMealStatus.each(function (ind, e) {
         var id = $(e).attr("id");
         var clazz = $(e).attr("class");
         $("#" + id).attr("class", clazz);
       });
       chooseMenuItems.attacheContextMenus();
     }, localStorage.language);
    */
  });
}

const chooseMenuItems = {
  contextmenu: false,
  attacheContextMenus: function () {
    $.contextMenu({
      selector: ".menuItemCategory",
      events: {
        show: function (options) {
          chooseMenuItems.contextmenu = true;
        },
        hide: function (options) {
          chooseMenuItems.contextmenu = false;
        }
      },
      build: function ($trigger, e) {
        var items = {};
        items["edit"] = {
          name: I18n.t("admin_local.edit"),
          icon: "edit"
        };
        return {
          callback: function (key, options) {
            chooseMenuItems.createTemplates();

            switch (key) {
              case "edit":
                var modal = $("#editMenuCategory").modal("show");
                var id = $trigger.attr("id").split("-");
                $("#editMenuCategory .modal-dialog").attr("id", "meals");
                id = id[id.length - 1];
                admin.getMenuCategoryById(id, function (data) {
                  orderListUtil.entityType = undefined;
                  orderListUtil.entitytype = undefined;
                  populateEditCategory(modal, "edit", data, data.menuCategoryId);
                  $("#allergens > label").on("click", toggleAllergen);
                  $("#category_allergens > label").on("click", toggleAllergen);
                });
                break;
            }
          },
          items: items
        };
      }
    });
    $.contextMenu({
      selector: ".menuItem",
      events: {
        show: function (options) {
          chooseMenuItems.contextmenu = true;
        },
        hide: function (options) {
          chooseMenuItems.contextmenu = false;
        }
      },
      build: function ($trigger, e) {
        var items = {};
        items["edit"] = {
          name: I18n.t("admin_local.edit"),
          icon: "edit"
        };
        return {
          callback: function (key, options) {
            chooseMenuItems.createTemplates();

            switch (key) {
              case "edit":
                var modal = $("#editMenuItem").modal("show");
                $("#editMenuItem .modal-dialog").attr("id", "meals");
                var id = $trigger.attr("menuitem");
                admin.getMenuItems((d) => {
                  admin.getMenuItemById(id, function (data) {
                    orderListUtil.entityType = undefined;
                    orderListUtil.entitytype = undefined;
                    populateEditMenuItem(modal, "edit", data, data.menuCategoryId);
                    $("#allergens > label").on("click", toggleAllergen);
                    $("#category_allergens > label").on("click", toggleAllergen);
                  });
                });
                break;
            }
          },
          items: items
        };
      }
    });
  },

  createTemplates: function () {
    var menu = $("#right_pane .tab-pane.menu.active");
    if (menu.attr("id") == "drink_menu_tab") {
      //utils = drinkutils;
      orderListUtil.entityType = "Drink";
      orderListUtil.entitytype = "drink";
    } else {
      //utils = mealutils;
      orderListUtil.entityType = "Meal";
      orderListUtil.entitytype = "meal";
    }
    $("div#editMenuItem").remove();
    $("div#editMenuCategory").remove();
    if ($("div#editMenuCategory").length == 0) {
      $("script#editMenuCategoryTemplate")
        .tmpl({
          onsave: "onsave",
          webshopEnabled: featureEnabled('ordering/enabled') && ((featureEnabled('pickup/enabled') && featureEnabled('pickup/webshop')) || (featureEnabled('homedelivery/enabled') && featureEnabled('homedelivery/webshop'))),
          entityType: orderListUtil.entityType,
          ...tmplparams()
        })
        .appendTo("body");
      $("script#editMenuItemTemplate")
        .tmpl({
          onsave: "onsave",
          webshopEnabled: featureEnabled('ordering/enabled') && ((featureEnabled('pickup/enabled') && featureEnabled('pickup/webshop')) || (featureEnabled('homedelivery/enabled') && featureEnabled('homedelivery/webshop'))),
          entityType: orderListUtil.entityType,
          entitytype: orderListUtil.entityType.toLowerCase(),
          ...tmplparams()
        })
        .appendTo("body");
      $('#editMenuItem').on('hidden.bs.modal', () => {
        $("div#editMenuItem").remove();
        $("div#editMenuCategory").remove();
      });
      $('#editMenuCategory').on('hidden.bs.modal', () => {
        $("div#editMenuItem").remove();
        $("div#editMenuCategory").remove();
      });

      $('#editMenuCategory > div').attr("id", "meal");
      var options = {
        placeholder: I18n.t("local.enter_additions"),
        tokensAllowCustom: true,
        searchMinLength: 0,
        dataSource: function (term, object) {
          object.trigger("tokenize:dropdown:fill", [menuitemutil.getMenuItems(term)]);
        },
        displayNoResultsMessage: true,
        noResultsMessageText: I18n.t("local.noResultsMessageText"),
        dropdownMaxItems: 7,
        searchFromStart: false
      };
      $("div#editMenuItem #item_additions_mandatory").tokenize2(options);
      $("div#editMenuItem #item_additions_included").tokenize2(options);
      $("div#editMenuItem #item_additions_optional").tokenize2(options);

      $("div#editMenuCategory #category_additions_mandatory").tokenize2(options);
      $("div#editMenuCategory #category_additions_included").tokenize2(options);
      $("div#editMenuCategory #category_additions_optional").tokenize2(options);
      menuitemutil.hooks();
    }
  },

  status: "normal",

  maximize: function (item) {
    if ($(item).hasClass("icon-maximize")) {
      chooseMenuItems.status = "maximized";
      $("#left_pane").hide();
      $(item).removeClass("icon-maximize");
      $(item).addClass("icon-minimize");
      $("#right_pane").css("height", "100%");
      $("#right_pane").css("width", "100%");
    } else {
      chooseMenuItems.status = "normal";
      $("#left_pane").css("display", "");
      updateLeftTabs();
      $(item).removeClass("icon-minimize");
      $(item).addClass("icon-maximize");

      var orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      if (orientation == "landscape") {
        if (typeof localStorage.table_overview_right_pane != "undefined") {
          $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
          $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
        } else {
          localStorage.table_overview_right_pane = 60;
          $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
          $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
        }
        $("#left_pane").css("height", null);
        $("#right_pane").css("height", null);
      } else {
        if (typeof localStorage.table_overview_right_pane_height != "undefined") {
          $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
          $("#left_pane").css("height", "calc(100% - " + localStorage.table_overview_right_pane_height + "%)");
        } else {
          localStorage.table_overview_right_pane = 60;
          $("#left_pane").css("height", "calc(100% - " + localStorage.table_overview_right_pane_height + "%)");
          $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
        }
        $("#left_pane").css("width", null);
        $("#right_pane").css("width", null);
      }
    }
  },

  minimize: function (item) {
    if ($(item).hasClass("icon-maximize")) {
      chooseMenuItems.status = "minimized";
      $("#right_pane").hide();
      $(item).removeClass("icon-maximize");
      $(item).addClass("icon-minimize");
      $("#left_pane").css("height", "100%");
      $("#left_pane").css("width", "100%");
    } else {
      chooseMenuItems.status = "normal";
      $("#right_pane").css("display", "");
      updateLeftTabs();
      $(item).removeClass("icon-minimize");
      $(item).addClass("icon-maximize");

      var orientation = window.innerWidth > window.innerHeight ? "landscape" : "portrait";
      if (orientation == "landscape") {
        if (typeof localStorage.table_overview_right_pane != "undefined") {
          $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
          $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
        } else {
          localStorage.table_overview_right_pane = 60;
          $("#left_pane").css("width", "calc(100% - " + localStorage.table_overview_right_pane + "%)");
          $("#right_pane").css("width", localStorage.table_overview_right_pane + "%");
        }
        $("#left_pane").css("height", null);
        $("#right_pane").css("height", null);
      } else {
        if (typeof localStorage.table_overview_right_pane_height != "undefined") {
          $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
          $("#left_pane").css("height", "calc(100% - " + localStorage.table_overview_right_pane_height + "%)");
        } else {
          localStorage.table_overview_right_pane = 60;
          $("#left_pane").css("height", "calc(100% - " + localStorage.table_overview_right_pane_height + "%)");
          $("#right_pane").css("height", localStorage.table_overview_right_pane_height + "%");
        }
        $("#left_pane").css("width", null);
        $("#right_pane").css("width", null);
      }
    }
  }
};


export const gotoTop = () => {
  /*
  if (searchActive == true) return;

  $("#editTable").removeClass("calendar-view");
  $("#editTable .day").addClass("hidden");
  $("#editTable .week").remove();

  $(".search").val("");
  var menu = $(".tab-pane.menu.active");
  menu.removeClass("categorySelected");
  $(menu.find(".menuItemCategory")).removeClass("selected2");
  $(menu.find(".menuItemCategory")).removeClass("selected");
  $(menu.find(".menuItemCategory")).addClass("hidden");
  $(menu.find(".menuItem")).addClass("hidden");
  $(menu.find(".menuItemCategory[level='1']")).removeClass("hidden");
  */
};

export const getAvailableQuantityLabel = (menuItem, q) => {
  var quantityType = /*o.quantityType ? o.quantityType : */ menuItem.quantityType;
  if (quantityType == "undefined" || quantityType == "" || quantityType == "none") return "";
  // if (o.quantity == 1 && quantityType == 'pcs')
  // return '';
  var quantity = q.quantity;
  var quantityLabel = getLocale(q?.quantityType?.name, menuitemutil.getLanguage());
  if (quantityLabel == "N/A") quantityLabel = "";
  if (quantityLabel != "" && menuItem.entityType == "Meal") {
    return quantityLabel;
  } else {
    var v = quantityLabel != "" ? quantityLabel + " " : "";
    v += Math.abs(quantity) == 1 && quantityType == "pcs" ? "" : "(" + (quantity + (Math.abs(quantity) == 1 && quantityType == "pcs" ? "" : quantityType == "" ? "" : " " + I18n.t("local." + quantityType))) + ")";
    return v;
  }
};

export default chooseMenuItems;
